module.exports = __webpack_public_path__ + "img/collection-memoireRingsGold.70ba718.jpg";